export default __webpack_public_path__ + "assets/images/screwsMask4-6ceefb17e4329ff29e015d0e645f8a40.jpg";